import { Chip } from '@otp/ui';
import { FieldOfficeCountOtp } from 'src/graphql/generated/graphql';

type CountOtpColumnProps = {
  column: 'otp1Count' | 'otp2Count' | 'otp3Count' | 'otp4Count';
  entity: FieldOfficeCountOtp;
};

export const CountOtpColumn = ({ column, entity }: CountOtpColumnProps) => {
  const currentCount = entity[column];
  const totalCount =
    entity.otp1Count + entity.otp2Count + entity.otp3Count + entity.otp4Count;
  const percentage = totalCount === 0 ? 0 : (currentCount / totalCount) * 100;

  return (
    <>
      {currentCount}
      <Chip label={`${percentage.toFixed(0)}%`} />
    </>
  );
};
